import { Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCRMMultiSelectErrorModal extends Layout {
    labelFailedLink: Label;
    labelFailedOrderCount: Label;
    labelFailedOrders: Label;
    labelFailedPipe: Label;
    labelStatus: Label;
    labelSuccessfulOrderCount: Label;
    labelSuccessfulOrders: Label;
    panelFailed: Panel;
    panelSuccess: Panel;
}
